import * as T from "../constants";

const initialState = {
    country: "US",
    language: "ENG",
}

const initialReducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case T.UPDATE_COUNTRY:
            return {
                ...state,
                ...payload
            }
        case T.UPDATE_LANGUAGE:
            return {
                ...state,
                ...payload
            }
        default:
            return state;
    }
}

export default initialReducer;
